import './numbers.scss';

/**
 * version    1.0
 * class      <type> (numbers)
 * classdesc  Component that manage the numbers
 */
export class Numbers {}
